import React, { Component } from 'react';
import Link from 'gatsby-link';

import Logo from '../assets/nigala-logo.jpg';

import styles from '../assets/css/landing.module.css';

class LandingHeader extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (

            <header className={styles.landingHeader + ' [ relative z-20 ]'}>

                <div className="bg-white pt-8">

                    <Link to="/">
                        <img src={Logo} className={styles.landingLogo} alt="Nigala Logo" />
                    </Link>

                </div>

                <span className={styles.landingHeaderSlant + ' [ block h-24 ]'}></span>

            </header>

        )
    }
}

export default LandingHeader


// WEBPACK FOOTER //
// ./src/components/LandingHeader.js